import moment from 'moment'
export const todayAsString = () => moment().format('YYYY-MM-DD')
